import { useEffect, useRef } from 'react';

// Read by the Images tab's `InnerWrapper` height.
const BANNER_HEIGHT_VARIABLE = '--new-design-banner-height';

/**
 * Publishes the banner's height as a CSS variable, so layouts sized against the
 * viewport (the Images tab locks the page with `overflow: hidden`) leave room for
 * it instead of pushing it off screen. 0 once the banner is closed.
 */
export const useBannerHeightVariable = () => {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const element = ref.current;
    if (!element) return undefined;

    const root = document.documentElement;
    const observer = new ResizeObserver(() =>
      root.style.setProperty(BANNER_HEIGHT_VARIABLE, `${element.offsetHeight}px`)
    );
    observer.observe(element);

    return () => {
      observer.disconnect();
      root.style.removeProperty(BANNER_HEIGHT_VARIABLE);
    };
  }, []);

  return ref;
};
